import { PriceChangeSubmissionStatus } from "@/graphql/codegen/graphql"

export const PRICE_CHANGE_SUBMISSION_STATUS_CHIP_CLASS: Record<PriceChangeSubmissionStatus, string> = {
  [PriceChangeSubmissionStatus.Draft]: "text-gray-900",
  [PriceChangeSubmissionStatus.Submitted]: "bg-primary-200 text-gray-900",
  [PriceChangeSubmissionStatus.Approved]: "bg-tertiary-green-100 text-gray-900",
  [PriceChangeSubmissionStatus.Denied]: "bg-secondary-200 text-gray-900",
  [PriceChangeSubmissionStatus.Reverted]: "bg-gray-200 text-gray-900",
} as const
